export const INTEGRATIONS_LIST = [
    {
        id: "gemini",
        title: "Google Gemini",
        subtitle: "IA Generativa do Google",
        meta: "AI"
    },
    {
        id: "openai",
        title: "OpenAI",
        subtitle: "ChatGPT e modelos GPT",
        meta: "AI"
    },
    {
        id: "evolution",
        title: "Evolution AI (Geral)",
        subtitle: "API de WhatsApp (Principal)",
        meta: "Msg"
    },
    {
        id: "evolution_financial",
        title: "Evolution AI (Financeiro)",
        subtitle: "Robô de Despesas (Pessoal)",
        meta: "Bot"
    },

]
